export function countFormatter(num: number | string): string {
  const rounded = Math.round(Number(num) * 10) / 10;
  const parts = rounded.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join(','); // объединяем с запятой вместо точки
}

export function countTotalFormatter(
  num: number | string,
  roundTo: 'int' | 'float' = 'float',
): string {
  const n = Number(num);
  const rounded = roundTo === 'int' ? Math.round(n) : Math.round(n * 10) / 10;

  const parts = rounded.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join('.');
}
